import { apiService } from '.';
import { Attachment } from '../shared/types/shared';

export const asyncGetAttachmentsByPqrId = async (
    pqrId?: string
): Promise<Attachment[]> => {
    try {
        const response = await apiService.get<{ items: Attachment[] }>(
            `/api/attachment/by-pqr/${pqrId}`
        );
        return response.items;
    } catch (error) {
        return [];
    }
};
